let $ = jQuery;

module.exports = {
  /*
  * This is a dialog plugin based heavily on the following accessible tool-tip
  * plugin:
  *
  * jQuery simple and accessible dialog tooltip window, using ARIA
  * Website: http://a11y.nicolas-hoffmann.net/dialog-tooltip/
  * License MIT: https://github.com/nico3333fr/jquery-accessible-dialog-tooltip-aria/blob/master/LICENSE
  *
  * It was alterd to create its own IDs and populate a dialog block based on a
  * referenced block of HTML. It no longer works as a tooltip but only as a way
  * to open predefined dialog window.
  *
  * The referenced HTML needs to be a direct sibling of the toggle button.
  *
  * To use: Simply add the correct class name to your button element and make sure
  * the content you'd like to see appear in the dialog is a direct sibling. Styling
  * for the dialog is based on the element that you intend to appear in the dialog.
  *
  */
  // loading tooltip ------------------------------------------------------------------------------------------------------------
  // init
  attach: function(context, settings) {

    if (context !== document) {
      return;
    }

    var dialogClass = 'js-dialog';
    var $js_tooltips = $('.' + dialogClass),
        $body = $('body');

    if ( $js_tooltips.length ) { // if there are at least one :)

      $js_tooltips.each( function(index_to_expand) {

        var $this = $(this),
            options = $this.data(),
            $tooltip_prefix_class = typeof options.tooltipPrefixClass !== 'undefined' ? options.tooltipPrefixClass + '-' : '',
            index_lisible = index_to_expand + 1;

        $this.attr({
          'id' : 'label-dialog-' + index_lisible
        });

        $this.data('tooltip-content-id', 'data-tooltip-content-' + index_lisible);

        $this.siblings('.js-dialog-content').attr({
          'id': 'data-tooltip-content-' + index_lisible
        });

      });
    }

    // jQuery formatted selector to search for focusable items
    var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";


    // events ------------------
    $body.off('click.openBodyDialog').on('click.openBodyDialog', function(event) {
      var $target = $(event.target);
      // if click outside => close
      if ( !$target.is('.js-dialogtooltip') && !$target.is('.' + dialogClass) && !$target.parents(".js-dialogtooltip").is(".js-dialogtooltip")) {
        $('.js-dialogtooltip').remove();
      }
    })
    .off('click.openElemDialog').on( 'click.openElemDialog', '.' + dialogClass, function( event ) {
      var $this = $(this),
        options = $this.data(),
        $tooltip_prefix_class = typeof options.tooltipPrefixClass !== 'undefined' ? options.tooltipPrefixClass + '-' : '',
        $tooltip_text = options.tooltipText || '',
        $tooltip_content_id = typeof options.tooltipContentId !== 'undefined' ? '#' + options.tooltipContentId : '',
        $tooltip_title = options.tooltipTitle || '',
        $tooltip_close_text = options.tooltipCloseText || 'Close',
        $tooltip_close_title = options.tooltipCloseTitle || options.tooltipCloseText,
        $tooltip_starter_id = $this.attr('id'),
        $tooltip_code,
        $dialog_code,
        $tooltip_inner,
        $tooltip_doc;

      // close tooltip and remove active one
      $('#js-dialog').remove();
      $('.js-dialog').removeClass('is-active');

      // Grab the content of the HTML.
      $tooltip_inner = $($tooltip_content_id).clone();
      $tooltip_inner.children('button').addClass($tooltip_prefix_class + 'tooltip__close');
      $tooltip_inner.children('button').attr({
        'id': 'js-tooltip-close',
        'data-focus-back': $tooltip_starter_id,
        'title': $tooltip_close_title
      });

      // Create the dialog block.
      $tooltip_code = document.createElement('dialog');
      $($tooltip_code).attr({
        'id': 'js-dialog',
        'class': 'js-dialogtooltip ' + $tooltip_prefix_class + 'tooltip ' + $tooltip_inner.attr('class'),
        'data-launched-by': 'click',
        'role': 'dialog',
        'aria-labelledby': 'tooltip-title'
      });

      // If the element has a js-hide, remove it.
      if ($($tooltip_code).hasClass('js-hide')) {
        $($tooltip_code).removeClass('js-hide');
      }

      // Create inner div, with role document. Content will go here.
      $tooltip_doc = document.createElement('div');
      $tooltip_doc.setAttribute('role', 'document');

      // Append new DOM.
      $tooltip_doc.innerHTML = $($tooltip_inner).html();
      $tooltip_code.innerHTML = $($tooltip_doc).html();

      // Chrome bug
      setTimeout(function(){ $( $tooltip_code ).insertAfter($this); }, 50);
      // fix for Chrome bug resolution…
      setTimeout(function(){ $('#js-tooltip-close').focus(); }, 51);

      $('#' + $tooltip_starter_id).addClass('is-active');

      event.preventDefault();

    });

    // close button and esc key
    $body.off('click.dialogClose').on( 'click.dialogClose', '#js-tooltip-close', function( event ) {

      var $this = $(this),
        $tooltip_launched_by = $this.parents('#js-dialog').attr('data-launched-by'),
        $focus_back = $('#' + $this.attr('data-focus-back'));


      $('#js-dialog').remove();
      $focus_back.focus();
      $focus_back.removeClass('is-active');

     })
     .off('keydown.dialogClose').on( "keydown.dialogClose", "#js-dialog", function( event ) {
        var $this = $(this);

        if ( event.keyCode == 27 ) { // esc
          $('#js-tooltip-close').click();
          event.preventDefault();
        }
        if ( event.keyCode == 9 ) { // tab or maj+tab

          // get list of all children elements in given object
          var children = $this.find('*');

          // get list of focusable items
          var focusableItems = children.filter(focusableElementsString).filter(':visible');

          // get currently focused item
          var focusedItem = $( document.activeElement );

          // get the number of focusable items
          var numberOfFocusableItems = focusableItems.length

          var focusedItemIndex = focusableItems.index(focusedItem);

          if ( !event.shiftKey && (focusedItemIndex == numberOfFocusableItems - 1) ){
            focusableItems.get(0).focus();
            event.preventDefault();
          }
          if ( event.shiftKey && focusedItemIndex == 0 ){
            focusableItems.get(numberOfFocusableItems - 1).focus();
            event.preventDefault();
          }
        }
     });
  }
};
